import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useBusinessStats = () => {
  const urlStr = `${getApiUrl()}/mega/stats/business`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};
